import React, { useState } from 'react'
import Toast from '@ingka/toast'
import { useTranslation } from 'react-i18next'

import { toastType } from 'models/propTypes'

import useDelay from 'hooks/useDelay'

const AddedToBagToast = ({ toast }) => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    useDelay(() => setIsOpen(true), 500)
    const {
        props: { name, count, failed },
    } = toast

    let message

    if (failed) {
        if (count && count > 1) {
            message = t('toasts.unable to add_other')
        } else {
            message = t('toasts.unable to add_one')
        }
    } else if (name) {
        message = t('toasts.named added to bag', { name })
    } else if (count && count > 1) {
        message = t('toasts.multiple added to bag_other', { count })
    } else {
        message = t('toasts.multiple added to bag_one', { count: 1 })
    }

    return <Toast text={message} isOpen={isOpen} onCloseRequest={() => setIsOpen(false)} onTransitionEnd={() => {}} />
}

AddedToBagToast.propTypes = {
    toast: toastType.isRequired,
}

export default AddedToBagToast
